export default {
  Inputfield: "Bitte eingeben ",
  Dropdownfield: "Bitte auswählen",
  Searchfield: "Suchen <object name>",
  createOrSelectTag: "Tag erstellen oder auswählen",
  search: "Suchen...",
  searchMeasurementsOrUnits: "Messungseinheiten oder Kategorien suchen",
};
